export const tabs = () => {
    const blocks = document.querySelectorAll(".section-business-types");

    if (!blocks.length) return;

    blocks.forEach((block) => {
        const links = block.querySelectorAll(".section-business-types__item a");
        const contents = block.querySelectorAll(".section-business-types__content");

        const ACTIVE_CONTENT = "section-business-types__content--active";

        const activateTab = (link) => {
            const href = link.getAttribute("href");
            const content = block.querySelector(href);

            // Сбрасываем состояние
            links.forEach((item) => {
                item.classList.remove("site-btn--solid");
                item.classList.add("site-btn--outlined");
            });

            contents.forEach((item) => {
                item.classList.remove(ACTIVE_CONTENT);
            });

            // Активируем текущую вкладку
            link.classList.remove("site-btn--outlined");
            link.classList.add("site-btn--solid");

            if (content) {
                content.classList.add(ACTIVE_CONTENT);
            }

            history.replaceState(null, "", href);
        };

        links.forEach((link) => {
            link.addEventListener("click", (e) => {
                e.preventDefault();
                activateTab(link);
            });
        });

        // Открытие по hash
        if (window.location.hash) {
            const hashLink = block.querySelector(
                `.section-business-types__item a[href="${window.location.hash}"]`
            );

            if (hashLink) {
                activateTab(hashLink);
                return;
            }
        }

        // Первая вкладка по умолчанию
        if (links.length) {
            activateTab(links[0]);
        }
    });
};